module Life.Components.ShareButton where

import Prelude

import Data.Maybe (Maybe(..), fromMaybe)
import Data.String (Pattern(..))
import Data.String as String
import Data.Traversable (fold, traverse)
import Effect (Effect)
import Elmish (ReactElement)
import Elmish.Dispatch as E
import Elmish.HTML.Styled as H
import Life.Types.Game.Life (class CellularAutomaton, class VisibleAutomaton)
import Life.Types.Game.Life as Life
import Life.Types.Preset as Preset
import Life.Types.Route as Route
import Life.Utils.Function as F
import Promise as Promise
import Web.Clipboard as Clipboard
import Web.HTML (window)
import Web.HTML.Location as Loc
import Web.HTML.Window (location, navigator)

type Args f r = Preset.State f
  ( shareHash :: Maybe String
  | r
  )

type Events =
  { onCopied :: Effect Unit
  }

view :: forall f r. VisibleAutomaton f => String -> Args f r -> Events -> ReactElement -> ReactElement
view className args { onCopied } =
  H.button_ className
    { onClick: E.handleEffect do
        origin <- window >>= location >>= Loc.origin
        path <- window >>= location >>= Loc.pathname
        _ <-
          window >>= navigator >>= Clipboard.clipboard
            >>= traverse \clipboard ->
              clipboard
                # Clipboard.writeText (shareText origin path)
                >>= Promise.then_ \_ -> do
                  onCopied
                  pure $ Promise.resolve unit
        pure unit
    , title: "Share"
    }
  where
    shareText origin path = fold
      [ "Made with Songs of Life\n\n"
      , Life.foldMap
          { life: shareGame
          , rows: 6
          , cols: 6
          , renderRow: (_ <> "\n")
          , renderCol: \living -> if living then "🟪" else "⬜️"
          }
      , "\n"
      , shareUrl origin path
      ]

    shareGame = args.shareHash >>= Route.decode # case _ of
      Just (Route.Share p) -> Preset.toLife p
      _ -> args.game

    shareUrl origin path = fold
      [ origin
      , F.transaction path (String.stripSuffix $ Pattern "/")
      , "/#/"
      , args.shareHash # fromMaybe (shareHash args)
      ]

shareHash :: forall f r. CellularAutomaton f => Preset.State f r -> String
shareHash args =
  Route.encode $ Route.Share $ Preset.fromState args
